// import React from 'react';

import type { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, Navigate, Outlet } from '@tanstack/react-router';

import { Administrator } from '@/_containers/administration';

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient;
}>()({
  notFoundComponent: () => <Navigate to="/" />,
  component: () => {
    return (
      <>
        <Administrator>
          <Outlet />
        </Administrator>
      </>
    );
  },
});
